import { Space, Table, Tag } from 'antd';
import 'antd/dist/antd.css'


function TableComponent({ columns, data, scroll }) {
    return (<Table scroll={scroll} columns={columns} dataSource={data} pagination={false} />);
}

export default TableComponent;